/** Base path for consolidated `workspaces` Cloud Function (workspace-scoped). */
export function workspaceBasePath(workspaceId: string): string {
  return `/workspaces/${encodeURIComponent(workspaceId)}`;
}

/** GET workspace (optional query merged with path `workspaceId`). */
export function workspaceGetUrl(workspaceId: string, query?: Record<string, string>): string {
  const qs = query && Object.keys(query).length ? new URLSearchParams(query).toString() : '';
  return `${workspaceBasePath(workspaceId)}${qs ? `?${qs}` : ''}`;
}

/** GET members for a workspace. */
export function workspaceMembersUrl(workspaceId: string, query?: Record<string, string>): string {
  const qs = query && Object.keys(query).length ? new URLSearchParams(query).toString() : '';
  return `${workspaceBasePath(workspaceId)}/members${qs ? `?${qs}` : ''}`;
}

/** GET workspace API audit log (admin tooling). */
export function workspaceApiAuditLogUrl(workspaceId: string, query?: Record<string, string>): string {
  const qs = query && Object.keys(query).length ? new URLSearchParams(query).toString() : '';
  return `${workspaceBasePath(workspaceId)}/api-audit-log${qs ? `?${qs}` : ''}`;
}

/** POST invite members. */
export function workspaceInviteMembersPath(workspaceId: string): string {
  return `${workspaceBasePath(workspaceId)}/invite-members`;
}

/** POST cancel invitation. */
export function workspaceCancelInvitationPath(workspaceId: string): string {
  return `${workspaceBasePath(workspaceId)}/cancel-invitation`;
}

/** POST remove member. */
export function workspaceRemoveMemberPath(workspaceId: string): string {
  return `${workspaceBasePath(workspaceId)}/remove-member`;
}

/** PUT update member role. */
export function workspaceMemberRolePath(workspaceId: string): string {
  return `${workspaceBasePath(workspaceId)}/member-role`;
}
